exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".project-info-content {\n  float: right; }\n\n.project-info-content-left {\n  width: 600px;\n  float: left; }\n\n.project-percentage {\n  color: white;\n  font-weight: 500;\n  border-radius: 3px;\n  padding: 3px 20px 3px 20px; }\n\n.oasis-font-size-item {\n  font-size: 15px; }\n\n.per-container {\n  width: 70px;\n  height: 31px; }\n\n.bg-tasks {\n  background-color: #f6f7f8;\n  color: black !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/dashboard-my-oasis/project-health/project-health.component.scss
// module id = ../../../../../src/app/dashboard-my-oasis/project-health/project-health.component.scss
// module chunks = main